export default __webpack_public_path__ + "static/media/collection1.0f9b3938.svg";